import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { flex, flexCenter } from "shared/theme/mixins";

export const StyledNoOptionContainer = styled(Box)`
  ${flex({ ai: "center", jc: "space-between" })}
  height: 40px;
  padding: 0;
  cursor: pointer;
`;

export const StyledLoadingContainer = styled(Box)`
  ${flexCenter()}
  width: 24px;
  height: 24px;
  stroke-width: 6px;

  .MuiCircularProgress-colorPrimary {
    color: ${COLOR_PRIMARY_MAIN};
  }
`;
